import { IllustrativeIcon } from '@vst/beam';
import { Alert } from '@vst/beam-icons/illustrative-icons';

import { Pages } from '@app/redux/streamOnPromo';

import { FlowEnd } from '../../components/FlowEnd';

import styles from './unavailable.module.scss';

export const UnavailablePage = () => {
  return (
    <FlowEnd namespace="UnavailablePage" page={Pages.unavailable} titleKey="Title" descriptionKey="SubTitle">
      <IllustrativeIcon className={styles['iconContainer']} icon={Alert} color="teal_600" />
    </FlowEnd>
  );
};
